"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./Style.css");

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _idbReactUiElements = require("@identitybuilding/idb-react-ui-elements");

var _reactDom = require("react-dom");

var _tinySliderReact = _interopRequireDefault(require("tiny-slider-react"));

var _idbReactTranslations = _interopRequireDefault(require("@identitybuilding/idb-react-translations"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var VideoLibrary = function VideoLibrary(props) {
  var _React$useState = _react["default"].useState(props.suggested_videos[0]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      current_video = _React$useState2[0],
      setCurrent_video = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(Object.keys(props.allRecepten)[0]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      tab = _React$useState4[0],
      setTab = _React$useState4[1];

  var _React$useState5 = _react["default"].useState(0),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      currentIndex = _React$useState6[0],
      setCurrentIndex = _React$useState6[1];

  var tinyRef = _react["default"].useRef();

  var Arrow = function Arrow(_ref) {
    var className = _ref.className,
        onClick = _ref.onClick,
        dir = _ref.dir;
    return /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      className: className,
      name: dir === "next" ? "ArrowRight" : "ArrowLeft",
      onClick: onClick
    });
  };

  var translate = function translate(x) {
    return (0, _idbReactTranslations["default"])(x, props.lang);
  };

  var settingsSlick = {
    arrows: true,
    dots: false,
    // infinite: true,
    lazyload: true,
    items: 2,
    nextArrow: /*#__PURE__*/_react["default"].createElement(Arrow, {
      dir: "next"
    }),
    prevArrow: /*#__PURE__*/_react["default"].createElement(Arrow, {
      dir: "prev"
    }),
    slidesToScroll: 1,
    slidesToShow: 4,
    responsive: [{
      breakpoint: 1206,
      settingsSlick: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 940,
      settingsSlick: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 678,
      settingsSlick: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 700,
      settingsSlick: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }],
    speed: 500,
    swipe: true,
    swipeToSlide: true,
    variableWidth: true,
    // variableHeight: true,
    pauseOnhover: true
  };
  var settingsTiny = {
    lazyload: true,
    nav: false,
    axis: true,
    preventScrollOnTouch: "auto",
    swipeAngle: true,
    mouseDrag: true,
    loop: true,
    items: 2,
    gutter: 10,
    controls: false,
    responsive: {
      420: {
        items: 3
      }
    }
  };

  var onGoTo = function onGoTo(dir) {
    return tinyRef.current.slider.goTo(dir);
  };

  return /*#__PURE__*/_react["default"].createElement("section", {
    id: "videoLibrary",
    className: [!props.template ? "temp-1" : "temp-" + props.template, !props.theme ? "light" : props.theme].join(" ")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "VideoLibrary"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "current-column"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "current_video"
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    className: "current_video_iframe",
    width: "100%",
    height: "500px",
    src: props.suggested_videos[currentIndex][props.lang ? "url_".concat(props.lang) : 'url_nl'],
    title: "YouTube video player",
    frameBorder: "0",
    allow: " accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    "x-frame-options": "DENY"
  }))), props.template !== 2 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "categories"
  }, Object.entries(props.allRecepten).map(function (_ref2, index) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return /*#__PURE__*/_react["default"].createElement("div", {
      key: key,
      className: "receptentab ".concat(tab === key ? "active" : ""),
      onClick: function onClick() {
        setTab(key);
        props.onNav(key);
        setCurrentIndex(0);
      }
    }, translate(key));
  }), " "), props.template !== 2 && /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], _extends({
    className: "suggested_videos"
  }, settingsSlick), props.suggested_videos && props.suggested_videos.map(function (video, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      onClick: function onClick() {
        setCurrent_video(props.suggested_videos[index]);
        setCurrentIndex(index);
      }
    }, /*#__PURE__*/_react["default"].createElement("iframe", {
      className: "video_list_iframe",
      src: video[props.lang ? "url_".concat(props.lang) : 'url_nl'],
      title: video[props.lang ? "title_".concat(props.lang) : 'title_nl'],
      frameBorder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: true,
      "x-frame-options": "DENY"
    }));
  })), props.template === 2 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "suggested_videos"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return onGoTo("prev");
    }
  }, "\u25B2"), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return onGoTo("next");
    }
  }, "\u25BC"), /*#__PURE__*/_react["default"].createElement(_tinySliderReact["default"], {
    ref: tinyRef,
    settings: settingsTiny
  }, props.suggested_videos && props.suggested_videos.map(function (video, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      onClick: function onClick() {
        setCurrent_video(props.suggested_videos[index]);
        setCurrentIndex(index);
      }
    }, /*#__PURE__*/_react["default"].createElement("iframe", {
      className: "video_list_iframe",
      src: video[props.lang ? "url_".concat(props.lang) : 'url_nl'],
      title: video[props.lang ? "title_".concat(props.lang) : 'title_nl'],
      frameBorder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: true,
      "x-frame-options": "DENY"
    }));
  })))), props.template === 2 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "categories"
  }, Object.entries(props.allRecepten).map(function (_ref4, index) {
    var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        value = _ref5[1];

    return /*#__PURE__*/_react["default"].createElement("div", {
      key: key,
      className: "receptentab ".concat(tab === key ? "active" : ""),
      onClick: function onClick() {
        setTab(key);
        props.onNav(key);
        setCurrentIndex(0);
      }
    }, translate(key));
  }), " "));
};

var _default = VideoLibrary;
exports["default"] = _default;